import { useEffect, useState } from "react";

const useJobRoles = (searchTerm) => {
  const [jobRoles, setJobRoles] = useState([]);

  useEffect(() => {
    const fetchJobRoles = async () => {
      if (!searchTerm) return; // Don't fetch if there's no search term

      try {
        const response = await fetch(`https://ec.europa.eu/esco/api/search?language=en&text=${searchTerm}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log(data); // Log the entire response for debugging
        setJobRoles(data._embedded?.results || []); // Set results or empty array if not found
      } catch (error) {
        console.error("Error fetching job roles:", error);
      }
    };

    fetchJobRoles();
  }, [searchTerm]); // Dependency on searchTerm

  return jobRoles;
};

export default useJobRoles; 